import Vue from "vue";
import { USER_NAME, USER_INFO } from "@/store/mutation-types";
import QrcodeVue from "qrcode.vue";
import { getActivityDetail } from "@/api/goods";
import { getAction } from "@/api/manage";
export default {
  name: "CourseGoodsDetail",
  components: {
    QrcodeVue: QrcodeVue
  },
  data: function data() {
    return {
      actId: "",
      //   userInfo: {},
      //   userId: "",
      activityInfo: {},
      buyQrcodeShow: false
    };
  },
  created: function created() {
    this.actId = this.$route.query.actId;
    this.userInfo = this.$store.state.user.info;
    // if (this.userInfo === null) {
    // } else {
    //   this.userId = this.userInfo.id;
    // }
    this.getActivityInfo();
  },
  methods: {
    getActivityInfo: function getActivityInfo() {
      var _this = this;
      getActivityDetail(this.actId).then(function (res) {
        _this.activityInfo = res.result;
        window.document.title = _this.activityInfo.landingTitle || _this.activityInfo.activityName;
      });
    },
    toBuy: function toBuy() {
      var _this2 = this;
      var h = this.$createElement;
      var that = this;
      console.log(Vue.ls.get(USER_INFO));
      if (Vue.ls.get(USER_INFO) != null) {
        // if(this.activityInfo.price == 0){
        getAction("/teaching/teachingActivity/freeByActivity?activityId=" + this.activityInfo.activityId).then(function (res) {
          if (res.success) {
            _this2.$message.success(res.message);
            _this2.$success({
              title: '领取成功',
              content: h("div", [h("p", ["\u60A8\u597D\uFF0CAICE\u6A21\u62DF\u7EC3\u4E60\u8BD5\u5377\u9ED8\u8BA4\u7531\u4E00\u7EA7\u5F00\u59CB\u5F00\u653E\u7EC3\u4E60\u6743\u9650\uFF0C\u901A\u8FC7\u540E\u5373\u53EF\u81EA\u52A8\u5F00\u653E\u4E0B\u4E00\u7EA7\u522B\u8BD5\u5377\uFF0C\u8BF7\u6839\u636E\u8001\u5E08\u7684\u8981\u6C42\u548C\u6307\u5BFC\uFF0C\u9009\u62E9\u5BF9\u5E94\u9879\u76EE\u8BD5\u5377\u5F00\u59CB\u7B54\u9898\uFF0C\u7B54\u9898\u7ED3\u675F\u540E\u5728\u201C\u6A21\u62DF\u7EC3\u4E60\uFF08\u56FE\u793A\u622A\u56FE\uFF09\u201D\u4E2D\u9009\u62E9\u201C\u67E5\u770B\u6211\u7684\u6A21\u62DF\u7EC3\u4E60\uFF08\u56FE\u793A\u622A\u56FE\uFF09\u201D\u4E86\u89E3\u7B54\u9898\u60C5\u51B5\u3002"])]),
              okText: '查看试卷',
              onOk: function onOk() {
                that.$router.push({
                  path: '/user/myPaper'
                });
              }
            });
          } else {
            _this2.$message.info(res.message);
          }
        });
        // }else{
        // this.buyQrcodeShow = true;
        // }
      } else {
        this.$message.error("请先登录");
      }
    },
    getBuyLink: function getBuyLink() {
      if (Vue.ls.get(USER_INFO) == null) {
        return "";
      }
      var url = window.location.protocol + "//" + window.location.host + "/mobile/landing.html?actId=" + this.actId + "&userId=" + Vue.ls.get(USER_INFO).id;
      return url;
    }
  }
};